import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  max-width: 460px;
  padding: 28px 36px;
  background-color: ${({ theme }) => theme.colors.grey.white};
  color: ${({ theme }) => theme.colors.grey.black};
  border-radius: 12px;
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
  }

  h1,
  h2,
  h3 {
    text-transform: uppercase;
    font-family: 'Anton', sans-serif;
  }

  h1 {
    display: flex;
    align-items: center;
    font-size: 138px;
    height: 138px;
  }

  h2 {
    display: flex;
    align-items: center;
    height: calc(68px + 8px);
    padding: 8px;
    font-size: 68px;
    color: ${({ theme }) => theme.colors.grey.white};
    background-color: ${({ theme }) => theme.colors.primary.main};
  }

  h3 {
    display: flex;
    align-items: center;
    font-size: 56px;
    height: 56px;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 12px;

  p {
    text-align: justify;

    b {
      font-weight: 700;
    }
  }

  a {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: underline;
    font-weight: 700;
  }
`;

export const GroupButton = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;
  gap: 12px;

  button {
    border: 0;
    background-color: ${({ theme }) => theme.colors.primary.main};
    color: ${({ theme }) => theme.colors.grey.white};
    padding: 8px;
    font-size: 28px;
    font-weight: 700;
    border-radius: 8px;
    letter-spacing: 1px;
    /* text-transform: uppercase; */
    font-family: 'Anton', sans-serif;
  }

  a {
    text-align: center;
    font-size: 16px;
    text-decoration: underline;
  }
`;
